import { MoneyCell } from '../money-cell/money-cell';
import { txDirection } from '@/lib/api/transactions';
import type { AccountTransaction } from '@/lib/api/types';
import { cn } from '@/lib/utils';

/** 流水金额单元格:按资金方向加 +/- 符号与红绿配色,已作废划线。字号/对齐/字重由 className 传入。 */
export function TransactionAmount({
  tx,
  className,
}: {
  tx: AccountTransaction;
  className?: string;
}) {
  const dir = txDirection(tx);
  const color = dir === 'credit' ? 'text-success' : dir === 'debit' ? 'text-destructive' : '';
  const sign = dir === 'credit' ? '+' : dir === 'debit' ? '-' : '';
  return (
    <div
      className={cn(
        'flex items-center gap-0.5 tabular-nums',
        tx.reversed && 'line-through opacity-40',
        className,
      )}
    >
      <span className={color}>{sign}</span>
      <MoneyCell value={tx.amount} className={color} />
    </div>
  );
}
